import { useAtomValue } from "jotai";
import { FC } from "react";

import { clientConfigAtom } from "atoms/clientConfig";

import { useStyles } from "./styles";

export const NavBar: FC = () => {
  const { classes } = useStyles();
  const { logo, displayName } = useAtomValue(clientConfigAtom);

  return (
    <nav className={classes.navbar}>
      <img src={logo} alt={`${displayName} logo`} className={classes.logo} />
    </nav>
  );
};
